import "./market.css";
import React from 'react';
import { coinIconUrls } from '../constants';

const CoinIcon = ({ id, size = 32 }) => {
  return <img src={coinIconUrls[id]} alt="" style={{ width: size, height: size, borderRadius: '50%' }} />;
};

function formatPrice(value) {
  if (!Number.isFinite(value)) return '—';
  return value < 1 ? value.toFixed(4) : value.toLocaleString();
}

const MarketPanel = ({ marketData, marketLoading = false, navigate, t }) => {
  const btc = marketData.bitcoin;
  const rest = ['ethereum','binancecoin','solana','pax-gold','ripple','dogecoin','cardano','avalanche-2'];
  return (
    <section className="hp-btc-panel">
      <div className="hp-mkt-inner">
        <div className="hp-mkt-header">
          <span className="hp-mkt-live">
            <span className="hp-btc-live-dot" />
            {t('home.btcLive')}
          </span>
        </div>
        {btc ? (
          <div className="hp-mkt-hero" style={{ cursor: 'pointer' }} onClick={() => navigate('/crypto/bitcoin')}>
            <div className="hp-mkt-hero-left">
              <CoinIcon id="bitcoin" size={36} />
              <div>
                <div className="hp-mkt-hero-name">Bitcoin <span className="hp-mkt-hero-symbol">BTC</span></div>
                <div className="hp-mkt-hero-price">${formatPrice(btc.current_price)}</div>
              </div>
            </div>
            <div className="hp-mkt-hero-right">
              <span className={`hp-btc-panel-change${btc.price_change_percentage_24h >= 0 ? ' up' : ' down'}`}>
                {btc.price_change_percentage_24h >= 0 ? '+' : ''}{btc.price_change_percentage_24h?.toFixed(2)}%
                <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
                  {btc.price_change_percentage_24h >= 0
                    ? <path d="M6 2L10 7H2L6 2Z"/>
                    : <path d="M6 10L2 5H10L6 10Z"/>
                  }
                </svg>
              </span>
              <span className="hp-mkt-hero-sub">H: ${formatPrice(btc.high_24h)} · L: ${formatPrice(btc.low_24h)}</span>
            </div>
          </div>
        ) : (
          <div className="hp-mkt-hero hp-mkt-hero--loading" aria-busy={marketLoading ? 'true' : 'false'}>
            <div className="hp-mkt-hero-left">
              <CoinIcon id="bitcoin" size={36} />
              <div>
                <div className="hp-mkt-hero-name">Bitcoin <span className="hp-mkt-hero-symbol">BTC</span></div>
                <div className="hp-mkt-hero-price hp-mkt-loading-text">正在同步行情</div>
              </div>
            </div>
            <div className="hp-mkt-hero-right">
              <span className="hp-btc-panel-change hp-mkt-skeleton hp-mkt-skeleton-badge" />
              <span className="hp-mkt-hero-sub hp-mkt-skeleton hp-mkt-skeleton-sub" />
            </div>
          </div>
        )}
        <div className="hp-mkt-row">
          {rest.map(id => {
            const c = marketData[id];
            if (!c) {
              return (
                <div key={id} className="hp-mkt-item hp-mkt-item--loading">
                  <CoinIcon id={id} size={24} />
                  <div className="hp-mkt-item-info">
                    <span className="hp-mkt-skeleton hp-mkt-skeleton-symbol" />
                    <span className="hp-mkt-skeleton hp-mkt-skeleton-price" />
                  </div>
                  <span className="hp-mkt-skeleton hp-mkt-skeleton-change" />
                </div>
              );
            }
            const up = c.price_change_percentage_24h >= 0;
            return (
              <div className="hp-mkt-item" key={id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/crypto/${id}`)}>
                <CoinIcon id={id} size={24} />
                <div className="hp-mkt-item-info">
                  <span className="hp-mkt-item-symbol">{c.symbol.toUpperCase()}</span>
                  <span className="hp-mkt-item-price">${formatPrice(c.current_price)}</span>
                </div>
                <span className={`hp-mkt-item-change${up ? ' up' : ' down'}`}>
                  {up ? '+' : ''}{c.price_change_percentage_24h?.toFixed(1)}%
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MarketPanel;
